const favorite = {
    state: {
        activeMark: null,
        activeArea: null,
        marks: [
            {
                x: 100,
                y: 100,
                text: 'asd'
            }
        ],
        areas: [],
        isAddMarkMode: false,
        isMarkEditorVisible: false,
        isMarkConfirmVisible: false,
        isMarkConfirmed: null,
        isMarkEditMode: false,
        markSavedText: ''
    },
    mutations: {
        SET_IS_ADD_MARK_MODE(state, payload) {
            state.isAddMarkMode = payload;
        },
        SET_ACTIVE_AREA(state, payload) {
            state.activeArea = payload;
        },
        SET_ACTIVE_MARK(state, payload) {
            state.activeMark = payload;
        },
        SET_MARKS(state, payload) {
            state.marks = payload;
        },
        ADD_MARK(state, payload) {
            state.marks = [...state.marks, payload];
        },
        REMOVE_MARK(state, payload) {
            state.marks.splice(payload, 1);
        },
        SET_MARK_TEXT(state, { index, text }) {
            state.marks[index].text = text;
        },
        ADD_AREA(state, payload) {
            state.areas = [...state.areas, payload];
        },
        REMOVE_AREA(state, payload) {
            state.areas.splice(payload, 1);
        },
        SET_AREA_TEXT(state, { index, text }) {
            state.areas[index].text = text;
        },
        SET_AREA_RESIZE(state, { index, area }) {
            state.areas[index] = { ...area };
        },
        SET_MARK_EDITOR_VISIBILITY(state, payload) {
            state.isMarkEditorVisible = payload;
        },
        SET_MARK_IS_CONFIRMED(state, payload) {
            state.isMarkConfirmed = payload;
        },
        SET_MARK_CONFIRM_VISIBILITY(state, payload) {
            state.isMarkConfirmVisible = payload;
        },
        SET_MARK_IS_EDIT_MODE(state, payload) {
            state.isMarkEditMode = payload;
        },
        SET_MARK_SAVED_TEXT(state, payload) {
            state.markSavedText = payload;
        }
    },
    actions: {
        addMark({ commit, dispatch }, payload) {
            commit('ADD_MARK', payload);
            dispatch('setActiveMark', payload);
        },
        addArea({ commit, dispatch }, payload) {
            commit('ADD_AREA', payload);
            dispatch('setActiveArea', payload);
        },
        setActiveMark({ state, commit, dispatch }, payload) {
            if (state.activeArea) {
                commit('SET_ACTIVE_AREA', null);
            }
            commit('SET_ACTIVE_MARK', payload);
            dispatch('showMarkConfirm');
            dispatch('showMarkEditor');
        },
        setActiveArea({ state, commit, dispatch }, payload) {
            if (state.activeMark) {
                commit('SET_ACTIVE_MARK', null);
            }
            commit('SET_ACTIVE_AREA', payload);
            dispatch('showMarkConfirm');
            dispatch('showMarkEditor');
        },
        resetMarks({
            state, commit, dispatch, rootGetters
        }) {
            if (state.activeMark) {
                commit('SET_ACTIVE_MARK', null);
            }
            if (state.activeArea) {
                commit('SET_ACTIVE_AREA', null);
            }
            dispatch('hideMarkEditor');
            dispatch('hideMarkConfirm');
            if (rootGetters.isMarkEditMode) {
                commit('SET_MARK_IS_EDIT_MODE', false);
            }
            if (state.markSavedText) {
                commit('SET_MARK_SAVED_TEXT', '');
            }
        },
        onCancelMark({ state, commit }) {
            /*
            * отмена добавления метки или отмена изменения текста метки в зависимости от режима
            */
            if (state.isMarkConfirmed !== null) {
                if (!state.isMarkConfirmed) {
                    if (state.isAddMarkMode) {
                        if (state.activeMark) {
                            commit('REMOVE_MARK', state.marks.length - 1);
                        } else if (state.activeArea) {
                            commit('REMOVE_AREA', state.areas.length - 1);
                        }
                    }
                    if (state.isMarkEditMode) {
                        if (state.activeMark) {
                            commit('SET_MARK_TEXT', {
                                index: state.marks.indexOf(state.activeMark),
                                text: state.markSavedText
                            });
                        } else if (state.activeArea) {
                            commit('SET_AREA_TEXT', {
                                index: state.areas.indexOf(state.activeArea),
                                text: state.markSavedText
                            });
                        }
                    }
                }
            }
        },
        showMarkConfirm({ state, commit }) {
            if (!state.isMarkConfirmVisible) {
                commit('SET_MARK_CONFIRM_VISIBILITY', true);
            }
        },
        hideMarkConfirm({ state, commit }) {
            if (state.isMarkConfirmVisible) {
                commit('SET_MARK_CONFIRM_VISIBILITY', false);
            }
        },
        showMarkEditor({ state, commit, rootGetters }) {
            if (rootGetters.isMobile && !state.isMarkEditorVisible) {
                commit('SET_MARK_EDITOR_VISIBILITY', true);
            }
        },
        hideMarkEditor({ state, commit, rootGetters }) {
            if (rootGetters.isMobile && state.isMarkEditorVisible) {
                commit('SET_MARK_EDITOR_VISIBILITY', false);
            }
        }
    },
    getters: {
        isAddMarkMode: state => state.isAddMarkMode,
        getActiveMark: state => state.activeMark,
        getActiveArea: state => state.activeArea,
        getMarks: state => state.marks,
        getAreas: state => state.areas,
        isMarkEditorVisible: state => state.isMarkEditorVisible,
        isMarkConfirmVisible: state => state.isMarkConfirmVisible,
        isMarkConfirmed: state => state.isMarkConfirmed,
        isMarkEditMode: state => state.isMarkEditMode,
        getMarkSavedText: state => state.markSavedText
    }
};

export default favorite;
